import React from "react";

export const TrendUpIcon = (props) => (
  <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
    <path d="M3 3v18h18" />
    <path d="M19 7l-7 7-3-3-4 4" />
  </svg>
);
export const DashboardIcon = (props) => (
  <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <path d="M3 10h18M9 4v16" />
  </svg>
);
export const MegaphoneIcon = (props) => (
  <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
    <path d="M3 11v2a4 4 0 0 0 4 4h1" />
    <path d="M21 8v8" />
    <path d="M15 8l6-3v14l-6-3" />
    <path d="M9 8v8" />
  </svg>
);
export const ShieldPayIcon = (props) => (
  <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
    <path d="M12 2l7 3v6c0 5-3.5 8.5-7 9-3.5-.5-7-4-7-9V5l7-3z" />
    <path d="M9 12h6M9 9h6" />
  </svg>
);
export const ClockIcon = (props) => (
  <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 3" />
  </svg>
);
export const StarIcon = (props) => (
  <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
    <path d="M12 3l2.9 6 6.6.6-4.9 4.2 1.5 6.2L12 17l-6.1 3 1.5-6.2L2.5 9.6 9.1 9z" />
  </svg>
);

export const partnerIconByKey = {
  revenue: TrendUpIcon,
  digital: DashboardIcon,
  reach: MegaphoneIcon,
  payments: ShieldPayIcon,
  time: ClockIcon,
  reviews: StarIcon,
};
